<button type="submit" class="button is-primary" 
  [disabled]="Animate || Disabled" (click)="Clicked($event)">
  <span class="icon-text">
    <span class="icon">
      <i class="fa" [ngClass]="Animate ? 'fa-spinner fa-pulse' : 'fa-' + Icon"></i>
    </span>
    <span>{{ButtonContext}}</span>

  </span>
</button>